/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail.ts";

function getGetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailUrl(
  courseRegistrationId: GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/grade-and-frequence/course-registrations/${courseRegistrationId}/grade-detail` as const,
  };
  return res;
}

/**
 * @description Retorna a média e frequência finais do aluno e todos os Módulos com suas Disciplinas (média + frequência por Disciplina) e cada Aula (nota + peso da avaliação). **(Requer Authorization para autenticação)**
 * @summary Detalhe de notas e frequências do aluno (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/course-registrations/:courseRegistrationId/grade-detail}
 */
export async function getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail(
  courseRegistrationId: GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail401
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail404
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetailUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
